import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { updateApplicationGuideline } from 'api/auth.api';

export const UpdateApplicationGuideline = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: updateApplicationGuideline,

    onSuccess: (res) => {
      toast({
        title: 'Application guideline updated',
        description: res?.data?.message || 'Updated successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to update ',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
